import { CountryCode } from 'libphonenumber-js';
import { useEffect, useState } from 'react';

import { countries } from './countries';

interface GeolocationResponse {
  country_code: string;
  country_name: string;
  city: string;
  region: string;
  ip: string;
}

export const detectUserCountry = async (): Promise<{ country: CountryCode; wasActuallyDetected: boolean }> => {
  try {
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (response.ok) {
      const data: GeolocationResponse = await response.json();
      const detectedCountryCode = data.country_code?.toUpperCase();

      if (detectedCountryCode && countries.some(country => country.code === detectedCountryCode)) {
        return {
          country: detectedCountryCode as CountryCode,
          wasActuallyDetected: true
        };
      }
    }
  } catch (error) {
    console.warn('Failed to detect country from IP:', error);
  }

  return { country: 'BH' as CountryCode, wasActuallyDetected: false };
};

export const useCountryDetection = () => {
  const [detectedCountry, setDetectedCountry] = useState<CountryCode>('BH' as CountryCode);
  const [isDetecting, setIsDetecting] = useState(true);
  const [isActuallyDetected, setIsActuallyDetected] = useState(false);

  useEffect(() => {
    const detectCountry = async () => {
      setIsDetecting(true);
      try {
        const { country, wasActuallyDetected } = await detectUserCountry();
        setDetectedCountry(country);
        setIsActuallyDetected(wasActuallyDetected);
      } catch (error) {
        console.error('Error detecting country:', error);
        setDetectedCountry('BH' as CountryCode);
        setIsActuallyDetected(false);
      } finally {
        setIsDetecting(false);
      }
    };

    detectCountry();
  }, []);

  return { detectedCountry, isDetecting, isActuallyDetected };
}; 